import { createContext } from 'react'

const MandateViewCtx = createContext()

export default MandateViewCtx
